var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavstevy = function SvgNavstevy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007BB3",
    d: "m19.61 15.155-4.574-2.676a6.58 6.58 0 0 0 1.463-4.25C16.5 5.042 14.484 3 12 3S7.5 5.042 7.5 8.229a6.58 6.58 0 0 0 1.463 4.25L4.39 15.155A3.2 3.2 0 0 0 3 17.941C3 19.631 4.06 21 5.366 21h13.266C19.94 21 21 19.631 21 17.941a3.2 3.2 0 0 0-1.39-2.786"
  })));
};
export default SvgNavstevy;